import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateMinLength } from 'hb-react/shared/utils/validators/minLength';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validatePassword = ({
  value,
  required,
  maxLength,
  minLength,
  ...validators
}) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if (maxLength && !error) {
    error = validateMaxLength(value, maxLength);
  }

  if (minLength && !error) {
    error = validateMinLength(value, minLength);
  }

  if (validators) {
    Object.values(validators).forEach((args) => {
      const [validator, message] = Array.isArray(args) ? args : [args];

      error = validator(value) ? message : null;
    });
  }

  return error;
};
